<script>
    export let Type = "Information";
    export let message = "There is currently no data to show";

    let Colour = "blue";
    let Colourclass = "no-results_info";
    let Icon = "error_outline";
    let Header = "Information";

    switch(Type)
    {
        case "Warning":
            Colour = "orange";
            Colourclass = "no-results";
            Icon = "report_problem";
            Header = "Attention!";
        break;
        case "Success":
            Colour = "green";
            Colourclass = "no-results_success";
            Icon = "thumb_up";
            Header = "Success";
        break;
    }

</script>


<div class="{Colourclass}">
    <div class="row">
        <div class="col-2 col-md-1 text-center">
            <div class="pt-4 pb-4" style="margin: 0 50% 0 50%;">
                <span class="material-icons bigger {Colour}">{Icon}</span>
            </div>
        </div>
        <div class="col-10 col-md-11">
            <div class="pt-4 pb-4 pl-4">
                {#if $$slots.content}
                    <strong style="font-size: 1.2em;"> <slot name="header" /></strong>
                    <slot name="content" />
                {:else}
                    <strong style="font-size: 1.2em;">{Header}</strong><br />
                    <p>{@html message}</p>
                {/if}
            </div>
        </div>
    </div>
</div>



<style>

</style>
